import React from 'react';
import moment from 'moment';
import { interviewScreenInstructions } from 'src/utils/interviewScreenInstructions';
import { useMeetingContext } from 'src/context/MeetingProvider';

const WaitingForHost = () => {
	const { meeting } = useMeetingContext();
	const waitingTime = moment(meeting?.startTime)
		.add(10, 'minutes')
		.format('hh:mm a');
	return (
		<div className="my-60 flex flex-col items-center justify-center gap-2 dark:text-white">
			<p className=" text-2xl font-bold">Waiting for host to Join.</p>
			<br />

			<div>
				<p className="text-lg">
					We request you to wait till <span className="font-bold text-blue-600 dark:text-blue-400">{waitingTime}</span>{' '}
					for our interviewer to join before dropping off.
				</p>
				<br />

				<p>Meanwhile, please ensure the following:</p>
				{interviewScreenInstructions.map(i => (
					<p key={i}>{i}</p>
				))}
			</div>
		</div>
	);
};

export default WaitingForHost;
